module.exports = __webpack_public_path__ + "assets/img/licence.a0824480.jpg";